/* LadeSue — product card carousel + product gallery carousel */

function ladesueCarousel(root, opts) {
  var track = root.querySelector(opts.track);
  if (!track) return;
  var slides = root.querySelectorAll(opts.slide);
  var dots = root.querySelectorAll(opts.dot || '[data-none]');
  var prev = root.querySelector(opts.prev);
  var next = root.querySelector(opts.next);
  var counter = opts.counter ? root.querySelector(opts.counter) : null;
  var index = 0;

  function width() { return track.clientWidth || 1; }

  function paint() {
    dots.forEach(function (d, n) { d.classList.toggle('active', n === index); });
    if (opts.thumbActive) {
      root.querySelectorAll(opts.thumbActive).forEach(function (t, n) {
        t.classList.toggle('active', n === index);
      });
    }
    if (counter) counter.textContent = index + 1;
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index === slides.length - 1;
  }

  function goTo(i) {
    index = Math.max(0, Math.min(i, slides.length - 1));
    track.scrollTo({ left: index * width(), behavior: 'smooth' });
    paint();
  }

  var ticking = false;
  track.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      var i = Math.round(track.scrollLeft / width());
      if (i !== index) { index = i; paint(); }
      ticking = false;
    });
  }, { passive: true });

  if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(index - 1); });
  if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); goTo(index + 1); });
  dots.forEach(function (d) {
    d.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      goTo(parseInt(d.dataset.carDot, 10));
    });
  });
  if (opts.thumb) {
    root.querySelectorAll(opts.thumb).forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.pdpGoto, 10)); });
    });
  }

  var startX = 0, moved = false;
  track.addEventListener('pointerdown', function (e) { startX = e.clientX; moved = false; });
  track.addEventListener('pointermove', function (e) { if (Math.abs(e.clientX - startX) > 8) moved = true; });
  track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); moved = false; } }, true);

  paint();
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.prod.has-car').forEach(function (card) {
    ladesueCarousel(card, {
      track: '[data-carousel]',
      slide: '.pcar-slide',
      dot: '[data-car-dot]',
      prev: '[data-car-prev]',
      next: '[data-car-next]'
    });
  });

  var gallery = document.querySelector('.pdp-gallery');
  if (gallery) {
    ladesueCarousel(gallery, {
      track: '[data-pdp-carousel]',
      slide: '.pdpcar-slide',
      prev: '[data-pdp-prev]',
      next: '[data-pdp-next]',
      counter: '[data-pdp-current]',
      thumb: '[data-pdp-goto]',
      thumbActive: '.pdp-thumb'
    });
  }
});
